import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-267">
      <TopBar data-id="element-268" />
      <Header data-id="element-269" />
      <main className="flex-1" data-id="element-270">
        <Outlet data-id="element-271" />
      </main>
      <Footer data-id="element-272" />
    </div>;
}